exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image {\r\n  width: 50px;\r\n  height: 50px;\r\n  border: none;\n}\n#dialog2{\r\n  display: none;\r\n  background: rgba(0,0,0,0.3);\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 999;\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  overflow: auto;\r\n  margin: 0;\n}\n#dia_box{\r\n  width: 350px;\r\n  height: 350px;\r\n  background: #fff;\r\n  margin: 0px auto 0px;\r\n  margin-top: 7%;\r\n  text-align: center;\r\n  border-radius: 5px;\n}\n#dia_box img{\r\n  margin: 20px auto;\r\n  padding-top: 50px;\n}\r\n", ""]);

// exports
